export default {
    computed:{
        ParkLotId:function(){
           return this.$store.state.order.parkLotId
        },
        GateId:function(){
            return this.$store.state.order.gateId;
        }
    },
    data() {
        return {
            // carSizeTable: ['不区分', '小型车', '中型车', '大型车', '新能源'],
            carSizeTable: [],
            titleType: ['', 'success', 'warning', 'danger', 'info'],
            array: ['blue','yellow','white','black','green'],
            bulletPlateSizeOptions: {
                1: '32px',
                2: '46px',
                3: '62px',
            },
            bulletPlateColorOptions: {
                1: 'black',
                2: 'red',
                3: 'yellow',
                4: 'blue',
            },
        }
    },
    methods:{
        showCarSizeTable(id) {
            let arr = this.carSizeTable.filter(v => {
                return id === v.Id
            });
            if (arr.length === 0) arr = [{Id: 1, Name: "不区分"}];
            return arr[0].Name
        },
    }
}
